import React from 'react';
import styled from '@emotion/styled';
import { A11yText } from '../../helpers';

const StyledIcon = styled.i`
  font-family: 'ECH Icons', serif;
  font-weight: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;
`;

const Icon = ({ iconName, title, ...rest }: IconProps) => {
  return (
    <>
      {title && <A11yText>{title}</A11yText>}
      <StyledIcon {...rest}>{iconName}</StyledIcon>
    </>
  );
};

export type IconProps = {
  /**
   * Icon Name based on ECH Icons font.
   * see https://fonts.ech.ch/fonts/ech_icons/ech_icons.woff
   * Use the name as ligature
   */
  iconName: string;
  /** Icon Title that will be used for accessibility */
  title?: string;
  /** Function that will get executed when clicking on the Icon */
  onClick?: () => void;
};

export default Icon;
